'use client';

import { useRef, useState } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation'
import Link from 'next/link';

// Assets
import Century21 from '@public/png/century-21-black-1.png';
import Hamburger from '@public/png/hamburger-1.png';
import XIcon from '@public/png/x-1.png';

// Hooks
import useWindowsSize from '@src/hooks/useWindowSize';
import useOutsideAlerter from '@src/hooks/useOutsideAlerter';
import useRedirect from '@src/hooks/useRedirect';

const TABS = [
  {
    label: "BERANDA",
    pathname: "/",
    isHide: false
  },
  {
    label: "PROPERTI",
    pathname: "/jual",
    isHide: false
  },
  {
    label: "TENTANG KAMI",
    pathname: "/about-us",
    isHide: false
  },
  {
    label: "KONTAK",
    pathname: "/contact",
    isHide: false
  },
]

const Tab = ({ label, pathname, currentPath }) => {
  const selectedClass = pathname === currentPath ? "!font-sfpro-semibold !text-black-1" : "";

  return (
    <Link href={pathname} className={`cursor-pointer mr-8 last:mr-0 text-13 text-grey-2 font-sfpro ${selectedClass}`}>{label}</Link>
  )
}

const Header = ({ className }) => {
  const redirect = useRedirect();
  const dropdownRef = useRef(null);

  const currentPath = usePathname()
  const { ddLG } = useWindowsSize()

  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const handleToHomepage = () => {
    redirect("/")
  }

  const handleOpenDropdown = () => {
    setIsOpenDropdown(true)
  }

  const handleCloseDropdown = () => {
    setIsOpenDropdown(false)
  }
  useOutsideAlerter(dropdownRef, handleCloseDropdown);
  return (
    <div className={`main-wrapper relative bg-white-3 ${className}`}>
      <div className='content-wrapper flex justify-between pt-6 pb-2'>
        <div className='cursor-pointer flex flex-col items-center 
        dd-lg:items-start' onClick={handleToHomepage}>
          <Image
            src={Century21}
            alt="CENTURY 21 Indonesia"
            width="auto"
            height="auto"
            className='cursor-pointer object-contain w-[143px] h-4 mb-2'
          />
          <p className='text-[12px] text-black-3 font-typold-extended-medium leading-[10.68px] tracking-[0.16px]'>Indonesia</p>
        </div>

        {ddLG ? (
          <Image onClick={handleOpenDropdown} src={Hamburger} alt='Hamburger' width={24} height={24} className='cursor-pointer object-contain' />
        ) : (
          <div className='flex items-center'>
            {TABS.map((t, i) => <Tab key={`century-21-tabs-${i}`} {...t} currentPath={currentPath} />)}
          </div>
        )}
      </div>

      {isOpenDropdown && (
        <div className='z-40 absolute left-0 top-0 w-full h-full flex flex-col items-center'>
          <div className='relative flex flex-col items-center z-[11] w-[calc(100vw-32px)] top-[16px]'>
            <div className='w-full p-[8px] pb-[16px] rounded-[16px] 
        border-[0.5px] border-solid border-grey-0 bg-white-3 shadow-[0_2px_8px_0_rgba(0,0,0,0.08)]'>
              {TABS.map((t, i) => {
                const isActive = t.pathname === currentPath;
                return <Link key={`century-21-tabs-${i}`} href={t.pathname} className={`bg-white-3 flex items-center justify-between text-22 text-grey-1 
            p-6 first:rounded-t-2xl last:rounded-b-2xl 
            ${isActive && "!text-black-1 font-sfpro-bold !bg-white-4"}
            `}>{t.label}</Link>
              })}
            </div>

            <div className='mt-[80px] bg-white-3 w-[48px] h-[48px] rounded-[40px] flex items-center justify-center'>
              <Image
                src={XIcon}
                width="auto"
                height="auto"
                alt='Close'
                className='w-[20px] h-[20px]'
                onClick={handleCloseDropdown}
              />
            </div>
          </div>
          <div className='gradient-8 absolute z-10 left-0 top-0 w-screen h-screen' />
        </div>
      )}
    </div>
  );
}

export default Header;
